import { Mic, MicOff, Square } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface MicrofoneButtonProps {
  isListening: boolean
  isSupported: boolean
  onStart: () => void
  onStop: () => void
  disabled?: boolean
}

export function MicrofoneButton({
  isListening,
  isSupported,
  onStart,
  onStop,
  disabled,
}: MicrofoneButtonProps) {
  if (!isSupported) {
    return (
      <Button
        variant="outline"
        size="lg"
        disabled
        className="h-24 w-24 rounded-full"
        aria-label="Microfone não suportado neste navegador"
      >
        <MicOff className="h-10 w-10 text-muted-foreground" />
      </Button>
    )
  }

  return (
    <Button
      type="button"
      size="lg"
      onClick={isListening ? onStop : onStart}
      disabled={disabled}
      aria-pressed={isListening}
      aria-label={isListening ? "Parar gravação" : "Iniciar gravação"}
      className={cn(
        "h-24 w-24 rounded-full transition-all",
        isListening
          ? "bg-red-600 hover:bg-red-700 animate-pulse"
          : "bg-primary hover:bg-primary/90",
      )}
    >
      {isListening ? (
        <Square className="h-10 w-10 fill-current" />
      ) : (
        <Mic className="h-10 w-10" />
      )}
    </Button>
  )
}
